import type { OnPageTransitionEndSync } from "vike/types";

export const onPageTransitionEnd: OnPageTransitionEndSync =
  (): ReturnType<OnPageTransitionEndSync> => {
    document.body.classList.remove("transitioning");
  };
